import Box from '@material-ui/core/Box';
import React from 'react';

import { AOButton } from '../AOButton';
import { AOCard } from '../AOCard';
import { Headline } from '../Headline';
import NewsArticles from './NewsArticles';

const NewsArticlesArchived = () => {
  return (
    <>
      <Box mb={2}>
        <AOButton color="secondary" route={'/'} startIcon="ArrowBack">
          Back to Home
        </AOButton>
      </Box>
      <Headline title="News" variant="h1" />
      <AOCard cardTitle="Agent News - Archived">
        <NewsArticles category="archive" newsType="inside-news" />
      </AOCard>
    </>
  );
};

export default NewsArticlesArchived;
